import { useState, useEffect } from 'react';

const getTwoDigitValue = value => {
    if (value < 10) {
        return '0' + value;
    }
    return '' + value;
}

const useTimer = (timeRemaining) => {
    const [day, setDays] = useState('--');
    const [hour, setHours] = useState('--');
    const [minute, setMinutes] = useState('--');
    const [second, setSeconds] = useState('--');
    const [isTime, setIsTime] = useState(false);
    const [isStarted, setIsStarted] = useState(false);
    const [startTime, setStartTime] = useState((new Date()).getTime());

    const calculateTime = () => {
        let timeElapsed = (new Date()).getTime() - startTime

        let seconds = (timeRemaining - timeElapsed) / 1000;

        if (seconds < 1) {
            setIsTime(true)
            return;
        }

        let days = Math.floor(seconds / (24 * 60 * 60)); // 1 day is equal to 24 hours, each hour has 60 mins and 60 seconds
        seconds -= days * 24 * 60 * 60; // Get remaining seconds

        let hours = Math.floor(seconds / (60 * 60)); // 1 hour has 60 mins and 60 seconds
        seconds -= hours * 60 * 60; // Get remaining seconds

        let minutes = Math.floor(seconds / 60); // 1 minute is equal to 60 seconds
        seconds -= minutes * 60; // Get remaining seconds

        days = Math.abs(days);
        hours = Math.abs(hours);
        minutes = Math.abs(minutes);
        seconds = Math.floor(Math.abs(seconds));
        setDays(getTwoDigitValue(days));
        setHours(getTwoDigitValue(hours));
        setMinutes(getTwoDigitValue(minutes));
        setSeconds(getTwoDigitValue(seconds));
        startTimer();
    }

    const startTimer = () => {
        setTimeout(calculateTime, 1000)
    }

    const initializeTimer = () => {
        if (!isStarted) {
            setIsStarted(true);
            setStartTime((new Date()).getTime());
        }
    }

    useEffect(() => {
        if (timeRemaining && isStarted) {
            calculateTime();
        }
    }, [timeRemaining, isStarted]);

    return {
        minute,
        second,
        isTime,
        initializeTimer,
    }
}

export default useTimer;
